<template>
  <div>
    <h5>InfoBar Stepper</h5>
    <!-- <DxStepper ref="stepperRef">
      <DxItem v-for="(item, index) in items" :key="index" :label="item.label" :icon="item.icon" />
    </DxStepper> -->
    <h4 style="color: cyan">{{ selectedStep }}</h4>

    <DxStepper
      id="customStepShape"
      :data-source="steps"
      :selected-index="selectedStepIndex"
      :linear="false"
      :element-attr="{ 'aria-labelledby': 'label-customStepShape' }"
      @selection-changed="onStepSelectionChanged"
    >
      <template #item="{ data, index }">
        <div @click="onStepItemClick(data, index)" class="step-item-clickable">
          <div class="dx-step-indicator">
            <i :class="'dx-icon dx-icon-' + data.icon" />
          </div>
          <div class="dx-step-caption">
            <div class="dx-step-label">{{ data.label }}</div>
            <div v-if="data.optional" class="dx-step-optional-mark">(Optional)</div>
          </div>
        </div>
      </template>
    </DxStepper>

    <!-- DxStepper Content Area -->
    <div v-if="selectedStep" class="dx-stepper-content-area">
      <div class="stepper-content-header">
        <h6>{{ selectedStep.label }} Content</h6>
        <button @click="closeDxStepperArea" class="close-btn">×</button>
      </div>
      <div class="stepper-content-body">
        <div class="content-section">
          <div class="step-info">
            <i :class="'dx-icon dx-icon-' + selectedStep.icon" class="step-icon"></i>
            <div class="step-details">
              <h7>{{ selectedStep.label }}</h7>
              <p>This is the content area for {{ selectedStep.label }}. You can add forms, data grids, or any other components here.</p>
              <div v-if="selectedStep.optional" class="optional-badge">Optional Step</div>
            </div>
          </div>

          <!-- Placeholder content based on step type -->
          <div class="step-specific-content">
            <div v-if="selectedStep.text === 'A'" class="cart-content">
              <h8>Cart Management</h8>
              <p>Manage cart items and quantities here.</p>
            </div>
            <div v-else-if="selectedStep.text === 'B'" class="shipping-content">
              <h8>Shipping Information</h8>
              <p>Enter shipping address and delivery preferences.</p>
            </div>
            <div v-else-if="selectedStep.text === 'C'" class="promo-content">
              <h8>Promotional Codes</h8>
              <p>Apply discount codes and special offers.</p>
            </div>
            <div v-else-if="selectedStep.text === 'D'" class="checkout-content">
              <h8>Checkout Process</h8>
              <p>Review order and complete payment.</p>
            </div>
            <div v-else-if="selectedStep.text === 'E'" class="order-content">
              <h8>Order Confirmation</h8>
              <p>Order has been placed successfully.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted } from "vue";
import { DxStepper, DxItem } from "devextreme-vue/stepper";

const items = reactive([
  { label: "Personal Details", template: "star" },
  { label: "Program Selection", icon: "detailslayout" },
  { label: "Campus and Start Dates", icon: "map" },
  { label: "Supporting Documents", icon: "textdocument" },
  { label: "Scholarship and Aid", icon: "money", optional: true },
  { label: "Review and Submit", icon: "send" },
]);

const steps = [
  {
    text: "A",
    label: "Cart",
    icon: "cart",
  },
  {
    text: "B",
    label: "Shipping Info",
    icon: "clipboardtasklist",
  },
  {
    text: "C",
    label: "Promo Code",
    icon: "gift",
    optional: true,
  },
  {
    text: "D",
    label: "Checkout",
    icon: "packagebox",
  },
  {
    text: "E",
    label: "Ordered",
    icon: "checkmarkcircle",
  },
];

const AreIdsShown = ref(true);
const selectedStep = ref(null);
const selectedStepIndex = ref(0);

const onStepItemClick = (data, index) => {
  selectedStep.value = data;
  selectedStepIndex.value = index;
  console.log("Step item clicked:", data.label, "at index:", index);
};

const onStepSelectionChanged = (e) => {
  if (e.addedItems && e.addedItems.length > 0) {
    const newItem = e.addedItems[0];
    const newIndex = steps.findIndex((step) => step.text === newItem.text);
    selectedStep.value = newItem;
    selectedStepIndex.value = newIndex;
    console.log("Step selection changed:", newItem.label);
  }
};

const closeDxStepperArea = () => {
  selectedStep.value = null;
};
</script>

<style scoped>
.star {
  aspect-ratio: 1;
  clip-path: polygon(50% 0, 79% 90%, 2% 35%, 98% 35%, 21% 90%);
  box-shadow: 0 0 0 8px #fafafa;
}

.dx-stepper-connector-value {
  background-color: red;
  transition-duration: 1s;
  transition-delay: 0.1s;
  transition-timing-function: steps(10, end);
}

.dx-stepper-connector-container {
  background-color: black;
}

.step-item-clickable {
  cursor: pointer;
  transition: all 0.3s ease;
}

.step-item-clickable:hover {
  transform: scale(1.05);
  background-color: rgba(0, 123, 255, 0.1);
  border-radius: 8px;
  padding: 4px;
}

.dx-stepper-content-area {
  margin-top: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stepper-content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.stepper-content-header h6 {
  margin: 0;
  color: #333;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background-color: #e0e0e0;
  color: #333;
}

.stepper-content-body {
  padding: 20px;
}

.content-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.step-info {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #007bff;
}

.step-icon {
  font-size: 24px;
  color: #007bff;
  margin-top: 4px;
}

.step-details h7 {
  margin: 0 0 8px 0;
  color: #333;
  font-weight: 600;
  font-size: 1.1em;
}

.step-details p {
  margin: 0 0 8px 0;
  color: #666;
  line-height: 1.5;
}

.optional-badge {
  display: inline-block;
  padding: 4px 8px;
  background-color: #ffc107;
  color: #212529;
  border-radius: 12px;
  font-size: 0.75em;
  font-weight: 500;
}

.step-specific-content {
  padding: 16px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background-color: #ffffff;
}

.step-specific-content h8 {
  margin: 0 0 12px 0;
  color: #495057;
  font-weight: 600;
  font-size: 1em;
}

.step-specific-content p {
  margin: 0;
  color: #6c757d;
  line-height: 1.4;
}

.cart-content {
  border-left: 3px solid #28a745;
  padding-left: 12px;
}

.shipping-content {
  border-left: 3px solid #17a2b8;
  padding-left: 12px;
}

.promo-content {
  border-left: 3px solid #ffc107;
  padding-left: 12px;
}

.checkout-content {
  border-left: 3px solid #fd7e14;
  padding-left: 12px;
}

.order-content {
  border-left: 3px solid #6f42c1;
  padding-left: 12px;
}
</style>
